<template>
  <item-nav :id="$attrs['id']">
    <item-nav-item :label="$t('layout.nav.admin.policyNav.overview')" link="policies" />
    <item-nav-group v-if="!isEmpty(policies)" :open="true" :label="$t('layout.nav.admin.policyNav.policies')">
      <template v-for="policy in policies" v-if="!policy.deleted">
        <item-nav-group-item :label="getName(policy.name)"
                             :params="routeParams(policy.id)"
                             :key="policy.id"
                             link="policy" />
      </template>
    </item-nav-group>

    <item-nav-group v-if="!isEmpty(deletedPolicies)" :label="$t('layout.nav.admin.policyNav.deletedPolicies')">
      <item-nav-group-item v-for="policy in deletedPolicies"
                           :label="getName(policy.name)"
                           :params="routeParams(policy.id)"
                           :key="policy.id"
                           link="policy" />
    </item-nav-group>

  </item-nav>
</template>

<script>

import { cloneDeep, isNil, isEmpty, keyBy } from 'lodash';
import ItemNavGroup from '../ItemNavGroup';
import ItemNavGroupItem from '../ItemNavGroupItem';
import HotelmeisterMixin from '../../../../../mixins/HotelmeisterMixin';

export default {
  name: 'PolicyNav',
  components: { ItemNavGroupItem, ItemNavGroup },

  mixins: [HotelmeisterMixin],
  props: [],

  data() {
    return {
      policies: [],
    };
  },

  computed: {
    deletedPolicies: function () {
      return this.policies.filter(it => it.deleted === true);
    },
  },

  created: function () {
    this.updatePolicies();

    this.$serviceBus.$on('policy.list', (data) => {
      if (isNil(data)) {
        this.updatePolicies();
      } else {
        this.policies = data;
      }
    });
  },

  mounted: function () {
    this.$emit('widenav', true);
  },

  methods: {
    updatePolicies() {
      this.axios.get(this.serviceUrls.policy.list(this))
        .then((response) => {
          this.policies = response.data.data;
        });
    },
    getName(name) {
      if (isNil(name)) return '-';
      let ret = null;

      ret = name;

      if (!isEmpty(ret)) return ret;

      return name[this.hotelSettings.details.primaryLanguage];
    },
    routeParams(policyId) {
      return {
        policyId: policyId,
      };
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  // @import '~styles/main';
</style>



// WEBPACK FOOTER //
// src/components/lib/layout/nav/admin/PolicyNav.vue